export const selectPermissions = (state) =>
  state.permissions?.permissions || [];

export const selectPermissionLoading = (state) =>
  state.permissions?.loading || false;

export const selectPermissionError = (state) =>
  state.permissions?.error || null;

export const selectSelectedPermission = (state) =>
  state.permissions?.selectedPermission || null;
